import { trackEvent } from '../analytics'
import { AdviseMark } from '../components/Motifs'
import { ADVISE, ADVISORY_TIERS, BOOKING_URL, BOOK_INTRO } from '../data/content'

export default function Advise() {
  return (
    <section className="sheet" id="advise">
      <div className="container">
        <div className="section-title">
          <AdviseMark className="section-mark" />
          <h2>{ADVISE.heading}</h2>
        </div>
        <p className="lede">{ADVISE.intro}</p>
        <div className="advise-layout">
          <div>
            <h3>{ADVISE.coversHeading}</h3>
            <ul className="clean-list">
              {ADVISE.covers.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="invoice">
            {ADVISORY_TIERS.map((tier) => (
              <div className="inv-row" key={tier.id}>
                <div className="inv-head">
                  <p className="inv-label">{tier.name}</p>
                  <p className="inv-amount">{tier.price}</p>
                </div>
                <ul className="inv-list">
                  {tier.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
            <p className="inv-terms">{ADVISE.terms}</p>
          </div>
        </div>
        <div className="btn-row section-cta">
          <a
            className="btn btn-primary"
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('booking_click', { location: 'advise' })}
          >
            {BOOK_INTRO}
          </a>
        </div>
      </div>
    </section>
  )
}
